var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoirTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconoir:trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 9L18.005 20.346C17.9236 20.8094 17.6815 21.2292 17.3212 21.5317C16.9609 21.8342 16.5055 22 16.035 22H7.965C7.49454 22 7.03913 21.8342 6.67882 21.5317C6.31852 21.2292 6.07639 20.8094 5.995 20.346L4 9M21 6H15.375M15.375 6V4C15.375 3.46957 15.1643 2.96086 14.7892 2.58579C14.4141 2.21071 13.9054 2 13.375 2H10.625C10.0946 2 9.58586 2.21071 9.21079 2.58579C8.83571 2.96086 8.625 3.46957 8.625 4V6M15.375 6H8.625M3 6H8.625",
    stroke: "#1C1612",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirTrash);
export default __webpack_public_path__ + "static/media/iconoir_trash.2c7917e92f1829589ec396d058d5514b.svg";
export { ForwardRef as ReactComponent };